<template>
  <div class="card-body" v-if="client">
    <client-details-row label="ID klienta" :value="client.clientId"/>
    <client-details-row label="Imiona" :value="client.firstName"/>
    <client-details-row label="Nazwisko" :value="client.lastName"/>
    <client-details-row label="PESEL" :value="client.pesel"/>
    <client-details-row label="Ulica" :value="client.street"/>
    <client-details-row label="Nr domu" :value="client.streetNo"/>
    <client-details-row label="Nr mieszkania" :value="client.flatNo"/>
    <client-details-row label="Kod pocztowy" :value="client.postalCode"/>
    <client-details-row label="Miasto" :value="client.city"/>
    <client-details-row label="Kraj" :value="client.country"/>
    <client-details-row label="Telefon 1" :value="client.phone1"/>
    <client-details-row label="Telefon 2" :value="client.phone2"/>
    <client-details-row label="Telefon komórkowy" :value="client.cellPhone"/>
    <client-details-row label="E-mail 1" :value="client.email1"/>
    <client-details-row label="E-mail 2" :value="client.email2"/>
    <client-details-row label="Dowód nr" :value="client.personalId"/>
    <client-details-row label="Uwagi" :value="client.comments"/>
    <client-details-row label="Zgoda na przetwarzanie danych" :value="client.zgodaNpdo ? 'TAK' : 'NIE'"/>
    <client-details-row label="Zgoda na wyświetlanie danych i rachunków"
                        :value="client.zgodaNprd ? 'TAK' : 'NIE'"/>
    <client-details-row label="Zgoda marketingowa" :value="client.zgodaNoih ? 'TAK' : 'NIE'"/>
    <client-details-row label="Zgoda E-mail" :value="client.zgodaEmail ? 'TAK' : 'NIE'"/>
    <client-details-row label="Karta magnetyczna" :value="client.kartamagn"/>
    <client-details-row label="Data utworzenia" :value="client.creationDate | datetime"/>
    <client-details-row label="Data aktualizacji" :value="client.modificationDate | datetime"/>
  </div>
</template>

<script>
  import clientDetailsRow from '@Component/client-details-row';

  export default {
    props: {
      client: Object,
    },
    components: {
      clientDetailsRow,
    }
  };
</script>
